import { SvgProps } from "components/icons/types";

export const Library = (props: SvgProps) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_7181_17164)">
      <path
        d="M12.3708 8.03891L9.04169 4.70983L7.87502 5.8765L4.49169 2.49316L3.66394 3.31508L7.87502 7.525L9.04169 6.35833L11.5459 8.86666L9.91669 10.493H13.125C13.3571 10.493 13.5796 10.4008 13.7437 10.2367C13.9078 10.0726 14 9.85006 14 9.618V6.40966L12.3708 8.03891Z"
        fill="currentColor"
      />
      <path
        d="M1.16667 12.236V0H0V12.236C0 12.7001 0.184374 13.1452 0.512563 13.4734C0.840752 13.8016 1.28587 13.986 1.75 13.986H14V12.8193H1.75C1.59529 12.8193 1.44692 12.7579 1.33752 12.6485C1.22812 12.5391 1.16667 12.3907 1.16667 12.236V12.236Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_7181_17164">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
